import {FC} from 'react';

import {Box, Button, Stack, Typography} from '@mui/material';

import {APK_LINK} from '../../api/api.config';

import logo from '../../assets/logo.png';

const DownloadMobileApp: FC = () => {
  return (
    <Box>
      <Stack
        minHeight="100vh"
        minWidth="100vw"
        direction="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        spacing={3}
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box sx={{height: '40px', width: '40px', '& > img': {height: '100%', width: '100%'}}}>
            <img src={logo} alt="Logo" />
          </Box>
          <Typography variant="h6" sx={{fontSize: {xs: '28px', sm: '32px'}}}>
            Сервис Трек
          </Typography>
        </Stack>
        <Button variant="contained">
          <a
            style={{textDecoration: 'none', color: 'inherit'}}
            href={APK_LINK}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            Скачать
          </a>
        </Button>
      </Stack>
    </Box>
  );
};

export default DownloadMobileApp;
